<template>
	<div class="job-costing-main">
		<div class="left-container">
			<div class="separator"></div>
			<div class="date-section">
				<Dropdown placeholder="Date Field" :items="dateFieldItems" itemKey="Date Field"
					:selectedObject.sync="selectedDateField" :errorMessage.sync="dateFieldError" :isRequired="true"
					@selected="showasat" />
				<div class="separator"></div>
				<div class="container">
					<div class="container-one">
						<DateTimePicker placeholder="From" :showTime="false" :value.sync="fromDatePicker" />
						<div class="separator"></div>
						<DateTimePicker style="margin-right: -3" placeholder="To" :showTime="false" :value.sync="toDatePicker" />
						<div class="separator"></div>
						<DateTimePicker placeholder="As At" :showTime="false" :value.sync="asAtDatePicker" />
					</div>
					<button style="margin-right: -5px" v-on:click="refreshClicked">Refresh</button>
					<div class="section-loader-button" v-if="filterLoaderRefreshButton">
						<div class="section-loader-text">{{ sectionLoaderText }}</div>
					</div>
				</div>
			</div>

			<div class="separator"></div>

			<Dropdown placeholder="Analysis Type" :items="analysisTypeItems" itemKey="Group By"
				:selectedObject.sync="selectedAnalysisType" :errorMessage.sync="analysisTypeError" />
			<div class="separator"></div>
			<Dropdown placeholder="Job Status" :items="jobStatusItems" itemKey="Job Status"
				:selectedObject.sync="selectedJobStatus" :errorMessage.sync="jobStatusError" />
			<div class="separator"></div>
			<Dropdown placeholder="Include Job Charges" :items="billpaidItems" itemKey="Charge Status Desc"
				:selectedObject.sync="selectedbillpaid" :errorMessage.sync="billpaidError" />
			<div class="separator"></div>
			<Dropdown placeholder="Credit Note" :items="chkCNItems" itemKey="Credit Note Status"
				:selectedObject.sync="selectedchkCN" :errorMessage.sync="chkCNError" />
			<div class="separator"></div>
			<Dropdown placeholder="Misc. Reciept" :items="chkMiscRtItems" itemKey="Misc Rt Status"
				:selectedObject.sync="selectedchkMiscRt" :errorMessage.sync="chkMiscRtError" />
			<div class="separator"></div>
			<Dropdown placeholder="Show.." :items="showItems" itemKey="Show Status"
				:selectedObject.sync="selectedshow" :errorMessage.sync="showError" />

			<div class="separator"></div>

			<div class="filter-container">
				<div class="filter-table1">
					<div class="separator"></div>
					<Filters class="gl-acc-filter" title="G/L Acc" :tableData="glAccData" itemKey="Acc No" itemDesc="Description"
						@confirmClicked="filterGLAccConfirm" />
					<Filters class="charge-code-filter" title="Charge Code" :tableData="chargeCodeData" itemKey="Charge Code"
						itemDesc="Description" @confirmClicked="filterChargeCodeConfirm" />
				</div>
				<div class="filter-table2">
					<div class="separator"></div>
					<Filters class="job-type-filter" title="Job Type" :tableData="JobTypeData" itemKey="JobType"
						itemDesc="Description" @confirmClicked="filterJobTypeConfirm" />
					<Filters class="customer-filter" title="Customer" :tableData="customerData" itemKey="Customer Code"
						itemDesc="Customer Name" @confirmClicked="filterCustConfirm" />
				</div>
			</div>
		</div>

		<div class="right-container">
			<div class="filtered-result">
				<div class="filtered-left">
					<div class="filtered-section">
						<div class="filtered-items">
							<div class="filtered-row">
								<div class="filter-title">{{ selectedDateFieldInfo }}</div>
								<div class="colon-separator">:</div>
								<div class="filter-details" >
									{{ fromDatePicker ? fromDatePicker.formatString('yyyy-MM-dd') : null }} to {{ toDatePicker ? toDatePicker.formatString('yyyy-MM-dd') : null}}
								</div>
							</div>
							<div class="filtered-row">
								<div class="filter-title">As At Date</div>
								<div class="colon-separator">:</div>
								<div class="filter-details">
									{{ asAtDatePicker ? asAtDatePicker.formatString('yyyy-MM-dd') : null }}
								</div>
							</div>
							<div class="filtered-row">
								<div class="filter-title">Group By</div>
								<div class="colon-separator">:</div>
								<div class="filter-details">
									{{ selectedAnalysisTypeInfo }}
								</div>
							</div>
							<div class="filtered-row">
								<div class="filter-title">Job Status</div>
								<div class="colon-separator">:</div>
								<div class="filter-details">
									{{ selectedJobStatusInfo }}
								</div>
							</div>
						</div>
						<div class="filtered-items">
							<div class="filtered-row">
								<div class="filter-title">G/L Acc</div>
								<div class="colon-separator">:</div>
								<div class="filter-details">{{ filteredGlAcc.length == 0 ? "All" : getGlAcc}}</div>
							</div>
							<div class="filtered-row">
								<div class="filter-title">Charge Code</div>
								<div class="colon-separator">:</div>
								<div class="filter-details">{{ filteredChargeCode.length == 0 ? "All" : getChargeCode}}</div>
							</div>
							<div class="filtered-row">
								<div class="filter-title">Job Type</div>
								<div class="colon-separator">:</div>
								<div class="filter-details">{{ filteredJobType.length == 0 ? "All" :  getJobType}}</div>
							</div>
							<div class="filtered-row">
								<div class="filter-title">Customer</div>
								<div class="colon-separator">:</div>
								<div class="filter-details">{{ filteredCustomer.length == 0 ? "All" : getCustomerCode }}</div>
							</div>
						</div>
						<div class="refresh-section">
							Last Refreshed : {{ refreshDate }}
						</div>
					</div>
				</div>
			</div>

			<div class="super-container">
				<!-- can change here maybe -->
				<!-- <div class="eight-boxes" v-if="!isRefreshed">
					<div class="filter-box" v-for="index in 8" :key="index" :style="index == 8 ? 'marginRight : 0px' : 'marginRight: '"><span>-</span><span>-</span></div>
				</div> -->
				<div class="eight-boxes">
					<div class="section-loader" v-if="filterLoaderEightBoxes">
						<div class="section-loader-text">{{ sectionLoaderText }}</div>
					</div>
					<div class="filter-box" v-for="(value, name, index) in filteredJobObject " :key="index"
						:style="index == Object.keys(filteredJobObject).length - 1 ? 'marginRight : 0px' : 'marginRight: '">
						<span id="data" :style="(parseFloat(value) < 0) ? 'color: red' : 'color: initial'">{{ value }}</span>
						<span id="label">{{ name }}</span>
					</div>
				</div>

				<!-- chart-container -->
				<div class="for-chart">
					<div class="chart-container">
						<div class="chart" id="first-chart">
							<div class="section-loader-chart" v-if="filterLoaderTopLeftContainer">
								<div class="section-loader-text">{{ sectionLoaderText }}</div>
							</div>
							<div class="chart-title">
								<span>Top 50 {{ selectedAnalysisTypeInfo }} by Gross Profit</span>
							</div>
							<div class="ct-chart-top50atpm" id="ct-chart-top50atpm"></div>
						</div>
					</div>

					<div class="chart-container">
						<div class="chart" id="second-chart">
							<div class="section-loader-chart" v-if="filterLoaderTopRightContainer">
								<div class="section-loader-text">{{ sectionLoaderText }}</div>
							</div>
							<div class="chart-title">
								<span>Bottom 50 {{ selectedAnalysisTypeInfo }} by Gross Profit</span>
							</div>

							<div class="ct-chart-btm50atpm" id="ct-chart-btm50atpm"></div>
						</div>
					</div>

				</div>
			</div>

			<div class="table-box-container"
				:style="{ maxHeight: tableBoxIsOpen ? '642px' : '', borderRadius: tableBoxIsOpen ? '5px' : '', border: tableBoxIsOpen ? '1px dotted gray' : '' }"
				>
				<!-- :title="!tableBoxIsOpen ? 'Open table box' : 'Close table box'" -->
				<div class="section-loader" style="height: 20px;" v-if="filterLoaderTableBox">
				</div>
				<div></div>
				<div class="table-box-label" :style="{ display: tableBoxIsOpen ? 'none' : 'initial' }" style="font-weight: bold;">
					Show Data
				</div>
				<div class="table-box-content" v-if="tableBoxIsOpen">
					<TableBox :dataType="tableDataType" style="padding: 5px;" title="Costing Analysis"
						:tableData="costingAnalysisOverview" :loading="tableIsLoading" :tableFilters="dataFilter"/>
				</div>
				<div :class="`table-box-icon ${!tableBoxIsOpen ? 'show-button' : 'close-button'}`">
					<img src="https://img.icons8.com/metro/26/000000/double-left.png" @click="tableBoxIsOpen = !tableBoxIsOpen"
						:style="{ 'transform': `rotate(${tableBoxIsOpen ? '270' : '90'}deg` }" />
				</div>
			</div>
		</div>

		<ContextMenu v-if="showContextMenu" :show.sync="showContextMenu" :position="contextPosition"
			:contextItems="contextItems" @contextEvent="drillThroughClicked" ref="context" :clickWithContext="true" style="max-width: fit-content" />

		<div class="chart-tooltip" v-if="showChartTooltip" :style="{ top: `${tooltipY}px`, left: `${tooltipX}px` }"
			ref="chart-tooltip">
			<div>{{ chartPointName }} <br> {{ chartPointValue }}</div>
		</div>
		

	</div>
</template>

<script>
/* eslint-disable */
let vuePage = null;
let labelHoverTimeout = null;

export default {
	data: function () {
		return {
			loading: false,
			loadText: 'Loading',
			filterLoaderEightBoxes: false,
			filterLoaderTableBox: false,
			filterLoaderTopLeftContainer: false,
			filterLoaderTopRightContainer: false,
			filterLoaderBottomLeftContainer: false,
			filterLoaderBottomRightContainer: false,
			filterLoaderRefreshButton: false,
			sectionLoaderText: 'Loading...',

			// date
			fromDateInfo: null,
			toDateInfo: null,
			fromDatePicker: new Date(new Date().getFullYear(), new Date().getMonth()),
			toDatePicker: new Date(new Date().getFullYear(), new Date().getMonth(), new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).getDate()),

			asAtDateInfo: null,
			// asAtDatePicker : new Date(new Date().getFullYear(),new Date().getMonth()),
			asAtDatePicker: new Date(new Date().getFullYear(), new Date().getMonth(), new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).getDate()),
			asAtDateError: '',

			refreshDate: '',
			fromDateError: '',
			toDateError: '',

			myJsonData: [],
			myformat: {},
			myFilter:{},
			myTitle: '',
			// dropdown
			dateFieldItems: [],
			dateFieldError: '',
			selectedDateFieldInfo: '',
			selectedDateField: {},
			filteredDateField: {},

			analysisTypeItems: [],
			analysisTypeError: '',
			selectedAnalysisTypeInfo: '',
			selectedAnalysisType: {},
			filteredAnalysisType: {},

			jobStatusItems: [],
			jobStatusError: '',
			selectedJobStatus: {},
			selectedJobStatusInfo: '',
			filteredjobStatus: {},

			billpaidItems: [],
			billpaidError: '',
			selectedbillpaid: {},
			selectedbillpaidInfo: '',
			filteredbillpaid: {},

			chkCNItems: [],
			chkCNError: '',
			selectedchkCN: {},
			selectedchkCNInfo: '',
			filteredchkCN: {},

			chkMiscRtItems: [],
			chkMiscRtError: '',
			selectedchkMiscRt: {},
			selectedchkMiscRtInfo: '',
			filteredchkMiscRt: {},

			showItems: [],
			showError: '',
			selectedshow: {},
			selectedshowInfo: '',
			filteredshow: {},
			// Display Info Boxes
			isRefreshed: false, // use for if data.length == 0 or when tune into page

			// Filters
			dataFilter: {},
			glAccData: [],
			selectedGlAcc: [],
			filteredGlAcc: [],
			getGlAcc: '',

			chargeCodeData: [],
			selectedChargeCode: [],
			filteredChargeCode: [],
			getChargeCode: '',

			JobTypeData: [],
			selectedJobType: [],
			filteredJobType: [],
			getJobType: '',

			customerData: [],
			selectedCustomer: [],
			filteredCustomer: [],
			getCustomerCode: '',

			dropDownItems: [],
			selectedDropdownItems: [],

			tableBoxIsOpen: false, // bottom table box to show API result in a whole
			tableIsLoading: false,
			tableDataType: {},

			chartBarHorTopFifty: null,
			chartBarHorBtmFifty: null,
			pieChartTopJob: null,
			chartBarHorTopFiftyJobs: null,


			costingAnalysisOverview: [],
			// filteredJobObject: {},
			filteredJobObject: {
				'Total Jobs': '-',
				'Jobs Pending Completion': '-',
				'Jobs Completed': '-',
				'Jobs Not Billed': '-',
				'Jobs Billed': '-',
				'Amount Billed': '-',
				'Total Gross Profit': '-',
				'Gross Profit %': '-'
			},
			customLegend: [],

			// showFullScreenPopup: false, // full screen feature still in working

			errorMessage: '<div style=\'padding-top: 100px; text-align: center; font-weight: bold; font-size: 10px;\'>An error occurred. Please try again.</div>',

			noRecordsMessage: '<div style=\'padding-top: 150px; text-align: center; font-weight: bold; font-size: 10px;\'>No records found.</div>',

			chartUnavailable: '<div style=\'padding-top: 150px; text-align: center; font-weight: bold; font-size: 10px;\'>No available data to generate chart.</div>',

			// Drill through context menu component
			showContextMenu: false,
			contextPosition: [0, 0],
			contextItems: [],

			getRptJobSummaryData: [],
			getCostingAnalysisSummaryData: [],
			getCostingAnalysisSumByJobData: [],
			getCostingAnalysisDetailsData: [],

			showChartTooltip: false,
			chartPointValue: '',
			chartPointName: '',
			chartPointMetaName: '',
			chartPointNameShort: '',
			chartPointDetails: '',
			tooltipX: 0,
			tooltipY: 0,

			analysisTypeConversion: {},
		};
	},
	methods: {
		//#region Filter Methods
		filterGLAccConfirm: function (items) {
			this.selectedGlAcc = items;
		},
		filterChargeCodeConfirm: function (items) {
			this.selectedChargeCode = items;
		},
		filterCustConfirm: function (items) {
			this.selectedCustomer = items;
		},
		filterJobTypeConfirm: function (items) {
			this.selectedJobType = items;
		},
		//#endregion

		//#region Create Chart Methods
		createChart: async function () {
			// replace blank template on chart ids
			$('#ct-chart-top50atpm').html('');
			$('#ct-chart-btm50atpm').html('');
			this.customLegend = [];
			// $('#ct-chart-topjobspm').html('');
			// $('#ct-chart-top50jobspm').html('');
			this.costingAnalysisOverview = [];
			// this.filteredJobObject = {};
			this.filteredJobObject = {
				'Total Jobs': '-',
				'Jobs Pending Completion': '-',
				'Jobs Completed': '-',
				'Jobs Not Billed': '-',
				'Jobs Billed': '-',
				'Amount Billed': '-',
				'Total Gross Profit': '-',
				'Gross Profit %': '-'
			};

			// reset chart objects as null
			if (this.chartBarHorTopFifty) {
				this.chartBarHorTopFifty.detach();
			}
			if (this.chartBarHorBtmFifty) {
				this.chartBarHorBtmFifty.detach();
			}

			if (this.asAtDatePicker.formatString('yyyy-MM-dd') < this.fromDatePicker.formatString('yyyy-MM-dd')) {
				this.$showAlert('error', 'Invalid As At Date', `Please select date after ${this.fromDatePicker.formatString('yyyy-MM-dd')} (From) `);
				this.filterLoaderRefreshButton = false;
				this.filterLoaderEightBoxes = false;
				this.tableIsLoading = false;
				this.filterLoaderTableBox = false;
				this.filterLoaderTopLeftContainer = false;
				this.filterLoaderTopRightContainer = false;

			} else {
				this.fromDateInfo = this.fromDatePicker.formatString('yyyy-MM-dd');
				this.toDateInfo = this.toDatePicker.formatString('yyyy-MM-dd');
				this.asAtDateInfo = this.asAtDatePicker.formatString('yyyy-MM-dd');
				this.refreshDate = new Date().formatString('yyyy-MM-dd HH:mm');
				// in strings

				this.selectedDateFieldInfo = this.selectedDateField == null ? '' : this.selectedDateField['Date Field'];
				this.selectedAnalysisTypeInfo = this.selectedAnalysisType == null ? '' : this.selectedAnalysisType['Group By'];
				this.selectedJobStatusInfo = this.selectedJobStatus == null ? '' : this.selectedJobStatus['Job Status'];
				this.selectedbillpaidInfo = this.selectedbillpaid == null ? '' :  this.selectedbillpaid['Charge Status'];
				this.selectedchkCNInfo = this.selectedchkCN == null ? '' :  this.selectedchkCN['ID'];
				this.selectedchkMiscRtInfo = this.selectedchkMiscRt == null ? '' : this.selectedchkMiscRt['ID'];
				this.selectedshowInfo = this.selectedshow == null ? '' : this.selectedshow['ID'];
				// get in Object
				this.filteredGlAcc = this.selectedGlAcc;
				this.getGlAcc = this.filteredGlAcc.length == 0 ? '' : this.filteredGlAcc.map((c) => { return c['Acc No'].trim(); }).join(',');

				this.filteredChargeCode = this.selectedChargeCode;
				this.getChargeCode = this.filteredChargeCode.length == 0 ? '' : this.filteredChargeCode.map((c) => { return c['Charge Code'].trim(); }).join(',');

				this.filteredCustomer = this.selectedCustomer;
				this.getCustomerCode = this.filteredCustomer.length == 0 ? '' : this.filteredCustomer.map((c) => { return c['Customer Code'].trim(); }).join(',');

				this.filteredJobType = this.selectedJobType;
				this.getJobType = this.filteredJobType.length == 0 ? '' : this.filteredJobType.map((c) => { return c['JobType'].trim(); }).join(',');

				let dataToPost = {
					'tmptblnaming': new Date().formatString('yyyyMMddHHmm'),
					'groupby': this.selectedAnalysisType == null ? '' : this.selectedAnalysisType['Group By'],
					'startgroup': '',
					'endgroup': '',
					'orderby': '',
					'strcust': this.getCustomerCode,
					'jobtype': this.getJobType,
					'datetype': this.selectedDateField == null ? '' : this.selectedDateField['Date Field'],
					'startdate': this.fromDateInfo,
					'enddate': this.toDateInfo,
					'asat': this.asAtDateInfo,
					'jobstatus': (this.selectedJobStatusInfo == 'All') ? '0' : (this.selectedJobStatusInfo == 'Complete Jobs Only') ? '1' : '2',
					'code': (this.filteredChargeCode.length == 0 & this.filteredGlAcc.length == 0) ? '0' : (this.filteredGlAcc.length == 0 ? '1' : '2'),
					'strcode': (this.filteredGlAcc.length == 0) ? this.getChargeCode : this.getGlAcc,
					'billpaid':  this.selectedbillpaidInfo,
					'chkcn': this.selectedchkCNInfo,
					'chkmiscrt':this.selectedchkMiscRtInfo,
					'chkloss': this.selectedshowInfo,
				}
				dataToPost['rpttype'] = 'DETAILS';
				this.getCostingAnalysisDetailsData = await this.$apiCallV2(`/JobCosting/GetJobCosting`, dataToPost);
				console.timeEnd("Details Data Time")
				dataToPost['rpttype'] = 'SUMBYJOB';
				this.getCostingAnalysisSumByJobData = await this.$apiCallV2(`/JobCosting/GetJobCosting`, dataToPost);
				console.timeEnd("SummaryByJobData Time")
				dataToPost['rpttype'] = 'SUMMARY';
				this.getCostingAnalysisSummaryData = await this.$apiCallV2(`/JobCosting/GetJobCosting`, dataToPost);
				console.timeEnd("SummaryData Time")
				if (!this.getCostingAnalysisSumByJobData || !this.getCostingAnalysisDetailsData || !this.getCostingAnalysisSummaryData) {
					this.filterLoaderRefreshButton = false;
					this.filterLoaderEightBoxes = false;
					this.tableIsLoading = false;
					this.filterLoaderTableBox = false;
					this.filterLoaderTopLeftContainer = false;
					this.filterLoaderTopRightContainer = false;
					this.filterLoaderBottomLeftContainer = false;
					this.filterLoaderBottomRightContainer = false;
				}

				await this.loadEightBoxes(this.getCostingAnalysisSumByJobData, this.getCostingAnalysisSummaryData);
				await this.createChartTopLeft(this.getCostingAnalysisDetailsData, this.selectedAnalysisTypeInfo);
				await this.createChartTopRight(this.getCostingAnalysisDetailsData, this.selectedAnalysisTypeInfo);
				await this.loadTableBoxData(this.getCostingAnalysisSummaryData);
				this.filterLoaderRefreshButton = false;

			}
		},
		createChartTopLeft: async function (data, analysisType) { //top 50
			if (!data) {
				return;
			}

			if (data.includes('error')) {
				document.getElementById('ct-chart-top50atpm').innerHTML = this.errorMessage;
			} else if (data.length == 0) {
				document.getElementById('ct-chart-top50atpm').innerHTML = this.noRecordsMessage;
			} else {

				let atObj = this.analysisTypeConversion.find(i => i[analysisType])[analysisType];
				let cuCode = [...new Set(data.map(d => d[atObj['columnName']]))];
				let sumObject = [];
				let allRevSum = [];

				this.getCostingAnalysisSummaryData.forEach(d => {
					let type = d['Customer'] ? d['Customer'] :
						(d['Customer GL Code'] ? d['Customer GL Code'] :
							(d['Job'] ? d['Job'] :
								(d['Sales Person'] ? d['Sales Person'] :
									(d['Sales Team'] ? d['Sales Team'] :
										(d['Service Person'] ? d['Service Person'] :
											(d['Service Team'] ? d['Service Team'] : d['Shipper/Consignee']))))));
					let code = d['Code'] ? d['Code']  :
										 (d['Job #'] ? d['Job #']: '' );
					allRevSum.push({
						name: type,
						name_short: code,
						totalRevenue: d['Gross Profit'],
					});
				});
				allRevSum.sort((a, b) => parseFloat(b.totalRevenue) - parseFloat(a.totalRevenue));
				let high = (Math.max(...allRevSum.map(i => Math.abs(i['totalRevenue']))) * 2) / 100;

				if (high === 0) {
					document.getElementById('ct-chart-top50atpm').innerHTML = this.chartUnavailable;
					this.filterLoaderTopLeftContainer = false;
					return;
				}
				allRevSum = allRevSum.slice(0, 50);
				let inputLabels = allRevSum.map(d => d['name_short']);
				let inputSeries = [allRevSum.map(d => {
					return { value: d['totalRevenue'].toFixed(2), meta: `${d['name']}|${JSON.stringify(d['details'])}` }
				})];

				if (inputLabels.length === 0 || inputSeries[0].length == 0) {
					document.getElementById('ct-chart-top50atpm').innerHTML = this.chartUnavailable;
					this.filterLoaderTopLeftContainer = false;
					return;
				}

				let chartData = {
					labels: inputLabels,
					series: inputSeries
				};

				var options = { axisX: { showLabel: true, showGrid: true }, axisY: { showGrid: false } };

				this.chartBarHorTopFifty = new Chartist.Bar('.ct-chart-top50atpm', chartData, options);
			}
			this.filterLoaderTopLeftContainer = false;
			console.timeEnd("ChartCreateTopLeft")

		},
		createChartTopRight: async function (data, analysisType) { //btm 50
			if (!data) {
				return;
			}

			if (data.includes('error')) {
				document.getElementById('ct-chart-btm50atpm').innerHTML = this.errorMessage;
			} else if (data.length == 0) {
				document.getElementById('ct-chart-btm50atpm').innerHTML = this.noRecordsMessage;
			} else {

				//Refer to line 469 to get explanation for codes here
				let atObj = this.analysisTypeConversion.find(i => i[analysisType])[analysisType];
				let cuCode = [...new Set(data.map(d => d[atObj['columnName']]))];
				let sumObject = [];
				let allRevSum = [];

				this.getCostingAnalysisSummaryData.forEach(d => {
					let type = d['Customer'] ? d['Customer'] :
						(d['Customer GL Code'] ? d['Customer GL Code'] :
							(d['Job'] ? d['Job'] :
								(d['Sales Person'] ? d['Sales Person'] :
									(d['Sales Team'] ? d['Sales Team'] :
										(d['Service Person'] ? d['Service Person'] :
											(d['Service Team'] ? d['Service Team'] : d['Shipper/Consignee']))))));
					let code = d['Code'] ? d['Code']  :
										 (d['Job #'] ? d['Job #']: '' );
					allRevSum.push({
						name: type,
						name_short: code,
						totalRevenue: d['Gross Profit'],
					});
				});
				allRevSum.sort((a, b) => parseFloat(a.totalRevenue) - parseFloat(b.totalRevenue));
				let high = (Math.max(...allRevSum.map(i => Math.abs(i['totalRevenue']))) * 2) / 100;

				if (high === 0) {
					document.getElementById('ct-chart-btm50atpm').innerHTML = this.chartUnavailable;
					this.filterLoaderTopRightContainer = false;
					return;
				}

				allRevSum = allRevSum.slice(0, 50);
				let inputLabels = allRevSum.map(d => d['name_short']);
				let inputSeries = [allRevSum.map(d => {
					return { value: d['totalRevenue'].toFixed(2), meta: `${d['name']}|${JSON.stringify(d['details'])}` }
				})];

				if (inputLabels.length === 0 || inputSeries[0].length == 0) {
					document.getElementById('ct-chart-top50atpm').innerHTML = this.chartUnavailable;
					this.filterLoaderTopLeftContainer = false;
					return;
				}

				var chartData = {
					labels: inputLabels,
					series: inputSeries
				};
				var options = { axisX: { showLabel: true, showGrid: true }, axisY: { showGrid: false } };

				this.chartBarHorBtmFifty = new Chartist.Bar('.ct-chart-btm50atpm', chartData, options);
			}
			this.filterLoaderTopRightContainer = false;
			console.timeEnd("ChartCreateTopRight")
		},
		refreshClicked: async function () {
			// activate the 4 boxes for display info (dashes -> data)
			this.isRefreshed = true;
			this.tableIsLoading = true;
			this.filterLoaderRefreshButton = true;
			this.filterLoaderEightBoxes = true;
			this.filterLoaderTableBox = true;
			this.filterLoaderTopLeftContainer = true;
			this.filterLoaderTopRightContainer = true;
			this.filterLoaderBottomLeftContainer = true;
			this.filterLoaderBottomRightContainer = true;
			this.chartPointDetails = '';
			this.chartPointMetaName = '';
			this.contextItems = [];
			// check whether all the filters/dropdowns are selected
			// if(!this.selectedDateField['Date Field'] || !this.selectedAnalysisType['Group By'] || !this.selectedJobStatus['Job Status']) return;
			this.checkError();
			await this.createChart();
			console.timeEnd("CreateChart")
			await this.addChartListeners();
			await this.addChartLabelHoverListeners();
		},
		drillThroughClicked: async function (item) {
			// when press on the contextMenu - post the Meta and Val to contextMenu to use them
			let titleName = item['target']['innerText'];
			if (titleName.includes('Top 50 Shipper/Consignee by Gross Profit')) {
				titleName = `Top 50 Shipper/Consignee by Gross Profit`;
			}

			if (titleName.includes('Bottom 50 Shipper/Consignee by Gross Profit')) {
				titleName = `Bottom 50 Shipper/Consignee by Gross Profit`;
			}

			// values in string [deserialize object into string]
			let type = this.selectedAnalysisTypeInfo;
			let atObj = this.analysisType.find(i => i[type])[type];
			let customerCodeRegex = this.chartPointMetaName.replace('&amp;', '&').slice(-14).match(/\((.*)\)/g) ? this.chartPointMetaName.replace('&amp;', '&').slice(-14).match(/\((.*)\)/g) : this.chartPointMetaName
			let customerCode = customerCodeRegex[0] ? customerCodeRegex[0].substring(1, customerCodeRegex[0].length - 1) : customerCodeRegex;

			let storageValueHash = {
				fromDate: this.fromDateInfo,
				toDate: this.toDateInfo,
				asAtDate: this.asAtDateInfo,
				// dropdown values
				selectedDateFieldInfo: this.selectedDateFieldInfo,
				selectedAnalysisTypeInfo: this.selectedAnalysisTypeInfo,
				selectedJobStatusInfo: this.selectedJobStatusInfo,
				// filter values in strings and comma separated
				getGlAcc: this.getGlAcc,
				getChargeCode: this.getChargeCode,
				getCustomer: this.getCustomerCode,
				getJobType: this.getJobType,
				lastRefresh: this.refreshDate,

				// title name for context menu clicked
				title: titleName,
				// store customer (topleft/topright) /job (bottomleft/bottomright) - name
				chosenMetaLong: this.chartPointMetaName.replace('&amp;', '&')
			};

			let storageKey = await this.$apiCallV2('/JobCosting/GetHash', storageValueHash);

			storageValueHash['tableData'] = titleName.includes('Job Costing Details by Job (All)') ? this.getCostingAnalysisSumByJobData : 
				titleName.includes('Job Costing Details by Job') ? this.getCostingAnalysisSumByJobData.filter(c => c[atObj['columnName']].includes(this.chartPointMetaName.replace('&amp;', '&'))) : 
				titleName.includes('Job Costing Details (All)') ? this.getCostingAnalysisDetailsData  : 
				titleName.includes('Job Costing Details') ? this.getCostingAnalysisDetailsData.filter(c => { return c['Customer Code'] == customerCode }) : '';
			
			let storageValue = JSON.stringify(storageValueHash);

			if(storageValue.length > 4000000) {
				let buttons = storageValue.length > 90000000 ? [{ text: 'Download' }	] : 
				 [{ text: 'Download' },{ text: 'Open', color: 'indianred', textColor: 'white' }];
				
				const donwloadOrShow = await this.$showAlert('warning', 'Large Drill Through Data', `The data for the drill through is very large to display (${db.sizeFormatter(storageValue.length)})<br><br> Please download to view.`, buttons);
				
				if (donwloadOrShow == 'Download') {
						this.myJsonData = titleName.includes('Job Costing Details by Job (All)') ? this.getCostingAnalysisSumByJobData : titleName.includes('Job Costing Details by Job') ? this.getCostingAnalysisSumByJobData.filter(c => c[atObj['columnName']].includes(this.chartPointMetaName.replace('&amp;', '&'))) : titleName.includes('Job Costing Details') ? this.getCostingAnalysisDetailsData.filter(c => { return c['Customer Code'] == customerCode }) : ''
						this.myformat = { // available data type string, number, date, currency
							'Job Date': 'date',
							'Invoice Date': 'date',
							'Amt Billed Excl Tax': 'currency',
							'Tax': 'currency',
							'Cost Excl Tax': 'currency',
							'Gross Profit': 'currency',
							'G. Profit Margin %': 'number',
							'KGM' : 'number',
							'M3' : 'number',
							'Payable' : 'number',
							'Job Not Billed' : 'number',
							'Job Completed' : 'number',
						};
						this.myTitle= titleName.includes('All') ? `${titleName}` : `${titleName} - ${this.chartPointMetaName.replace('&amp;', '&')}`;

						await this.$fullscreenLoading('Creating Excel');
						await this.$jsonToExcel(this.myTitle , this.myJsonData, this.myformat);
						await this.$fullscreenLoading();
				} else {
					await db.set(storageKey, JSON.parse(storageValue));
					let drillThroughLink = this.$router.resolve(`/Home/${this.$route['params']['user']}/Dashboard/Job Costing Drill Through?key=${storageKey}`).href;
					window.open(drillThroughLink, '_blank');
					// sessionStorage.clear();
				}
			}else{
				await db.set(storageKey, JSON.parse(storageValue));
				let drillThroughLink = this.$router.resolve(`/Home/${this.$route['params']['user']}/Dashboard/Job Costing Drill Through?key=${storageKey}`).href;
				window.open(drillThroughLink, '_blank');
			}
		},
		addChartListeners: async function () {
			$('document').ready(() => {
				//#region Top Left
				$('.ct-chart-top50atpm .ct-series-a .ct-bar').on('mousemove', function (event) { vuePage.chartsMouseMove(this, event, true) });

				$('.ct-chart-top50atpm .ct-series-a .ct-bar').on('mouseout', function (event) { vuePage.showChartTooltip = false });

				$('.ct-chart-top50atpm .ct-series-a .ct-bar').on('click', function (event) { vuePage.chartsClick(this, event) });
				//#endregion

				//#region Top Right
				$('.ct-chart-btm50atpm .ct-series-a .ct-bar').on('mousemove', function (event) { vuePage.chartsMouseMove(this, event, true) });

				$('.ct-chart-btm50atpm .ct-series-a .ct-bar').on('mouseout', function (event) { vuePage.showChartTooltip = false });

				$('.ct-chart-btm50atpm .ct-series-a .ct-bar').on('click', function (event) { vuePage.chartsClick(this, event, [`Job Costing Details by Job (All)`, `Job Costing Details by Job`, `Job Costing Details`,`Job Costing Details (All)`]) });
				//#endregion
			});
		},
		addChartLabelHoverListeners: function () {
			//#region Get DOM Element
			setTimeout(() => {
				let labelsTop50 = Array.from(this.chartBarHorTopFifty['container'].getElementsByClassName('ct-horizontal'));
				let labelsBtm50 = Array.from(this.chartBarHorBtmFifty['container'].getElementsByClassName('ct-horizontal'));
				// let labelsTop50Jobs = Array.from(this.chartBarHorTopFiftyJobs['container'].getElementsByClassName('ct-horizontal'));	

				let fObjectTop50 = labelsTop50.map(l => l.parentNode);
				let fObjectBtm50 = labelsBtm50.map(l => l.parentNode);
				// let fObjectTop50Jobs = labelsTop50Jobs.map(l => l.parentNode);

				// Need both
				fObjectTop50[fObjectTop50.length - 1].setAttribute('width', fObjectTop50[fObjectTop50.length - 2].getAttribute('width'));
				fObjectBtm50[fObjectBtm50.length - 1].setAttribute('width', fObjectBtm50[fObjectBtm50.length - 2].getAttribute('width'));
				// fObjectTop50Jobs[fObjectTop50Jobs.length - 1].setAttribute('width', fObjectTop50Jobs[fObjectTop50Jobs.length - 2].getAttribute('width'));

				fObjectTop50[fObjectTop50.length - 1].children[0].style.setProperty('width', fObjectTop50[fObjectTop50.length - 2].children[0].getAttribute('width'), 'important');
				fObjectBtm50[fObjectBtm50.length - 1].children[0].style.setProperty('width', fObjectBtm50[fObjectBtm50.length - 2].children[0].getAttribute('width'), 'important');
				// fObjectTop50Jobs[fObjectTop50Jobs.length - 1].children[0].style.setProperty('width', fObjectTop50Jobs[fObjectTop50Jobs.length - 2].children[0].getAttribute('width'), 'important');
				//

				let fObject = fObjectTop50;
				fObject = fObject.concat(fObjectBtm50);
				// fObject = fObject.concat(fObjectTop50Jobs);

				fObject.forEach(f => {
					f.addEventListener('mouseenter', (e) => {
						let parent = e.target.parentNode; // ct-labels
						parent.appendChild(f); // rearrange fobject to make it appear at top most (svg)

						labelHoverTimeout = setTimeout(() => {
							let span = e.target.children[0];
							span.style.setProperty('font-size', '1em');
							span.style.setProperty('overflow', 'visible');
							span.style.setProperty('padding', '5px');
							span.style.setProperty('transform', 'rotate(0deg) translate(-5px, -5px)');
							span.style.setProperty('background-color', 'black');
							span.style.setProperty('border-radius', '5px');
							span.style.setProperty('color', 'white', 'important');
							span.style.setProperty('width', 'fit-content', 'important');

							setTimeout(() => {
								let spanRight = e.target.children[0].getBoundingClientRect().right;
								let svgRight = e.target.parentNode.parentNode.getBoundingClientRect().right;

								if (spanRight >= svgRight) {
									let translateValue = Math.ceil(spanRight - svgRight) + 5;
									span.style.setProperty('transform', `translateX(-${translateValue}px)`);
								}
							}, 300);
						}, 1);
					});

					f.addEventListener('mouseout', (e) => {
						if (labelHoverTimeout) {
							clearTimeout(labelHoverTimeout);
							labelHoverTimeout = null;
						}
						let span = e.target.children[0];
						span.style.setProperty('font-size', '0.7em');
						span.style.setProperty('overflow', 'visible');
						span.style.setProperty('padding', '');
						span.style.setProperty('transform', 'rotate(-45deg)');
						span.style.setProperty('background-color', '');
						span.style.setProperty('color', '');
						span.style.setProperty('width', '');
					});
				});
			}, 1000);
			//#endregion
		},
		chartsMouseMove: function (chartist, event, checkZero) {
			let meta = chartist.getAttribute('ct:meta');
			let value = chartist.getAttribute('ct:value');
			let metaValue = meta.split('|');
			let isZero = metaValue[metaValue.length - 1] == 'true';

			this.showChartTooltip = true;
			this.chartPointValue = `RM ${checkZero ? `${isZero ? '0' : value}` : value}`;
			this.chartPointName = metaValue[0].replace(/&amp;/g, '&').trim();

			this.$nextTick(() => {
				try {
					let el = this.$refs['chart-tooltip'].getBoundingClientRect();
					this.tooltipX = (event.pageX - el.width) + 100;
					this.tooltipY = event.pageY - el.height;
				} catch (e) { console.log(e) }
			});
		},
		chartsClick: function (chartist, event) {
			this.showContextMenu = true;
			let meta = chartist.getAttribute('ct:meta');
			let metaValue = meta.split('|');
			this.chartPointDetails = metaValue[1].replace(/&quot;/g, '"');
			this.chartPointMetaName = metaValue[0];
			var regExp =/\(([^()]+)\)[^()]*$/;
			var matches = regExp.exec(this.chartPointMetaName);
			this.contextItems = [`Job Costing Details by Job (All)`, `Job Costing Details by Job for ${matches ? matches[1] : this.chartPointMetaName}`, `Job Costing Details (All)`, `Job Costing Details for ${matches ? matches[1] : this.chartPointMetaName}`];
			this.$nextTick(() => {
				try {
					this.contextPosition = [event.pageY - 130, event.pageX - 160];
				} catch (e) { console.log(e) }
			});
		},
		loadTableBoxData: async function (data) {
			if (data.includes('error') || data.length == 0) {
				this.costingAnalysisOverview = [];
				this.tableIsLoading = false;
				this.filterLoaderTableBox = false;
			} else {
				let dateConvertedData = [];

				this.tableDataType = { // available data type string, number, date, currency
					'Amt Billed Excl Tax': 'currency',
					'Tax': 'currency',
					'Total Cost': 'currency',
					'Gross Profit': 'currency',
					'G. Profit Margin %': 'currency',
					'Jobs Billed': 'number',
					'Jobs Not Billed': 'number',
					'Jobs Not Billed': 'number',
					'Cost Excl Tax': 'currency',
					'M3': 'number',
					'KGM': 'number',
					'Job Not Billed': 'number',
					'Job Completed': 'number',
				};

				dateConvertedData = this.getCostingAnalysisSummaryData;
				this.$nextTick(() => {
					this.costingAnalysisOverview = dateConvertedData;
					this.tableIsLoading = false;
					this.filterLoaderTableBox = false;
				});
			}
		},
		loadEightBoxes: async function (dataOnRight, summary) {
			if (dataOnRight == 0) {
				this.filteredJobObject = {};
				this.filterLoaderEightBoxes = false;
				this.isRefreshed = false;
				return;
			} else {
				var tempData = dataOnRight;
				var tempData2 = summary;
				let temp = {};
				let CostExclTax = tempData.map((data) => { return data['Cost Excl Tax'] }).reduce((a, b) => { return a + b })
				let AmountBilled = tempData.map((data) => { return data['Amt Billed Excl Tax'] }).reduce((a, b) => { return a + b })
				let JobCompleted = tempData.map((data) => { return data['Job Completed'] }).reduce((a, b) => { return a + b })
				let JobNotBilledList = tempData2.map((data) => { return data['Jobs Not Billed'] }).reduce((a, b) => { return a + b })
				let JobBilledList = tempData2.map((data) => { return data['Jobs Billed'] }).reduce((a, b) => { return a + b })
				let tempChecking = isNaN(JobCompleted) ? 0 : JobCompleted;
				let tempAmountBilled = this.$currencyFormat(AmountBilled);
				let tempTotalGP = this.$currencyFormat(AmountBilled - CostExclTax);

				temp['Total Jobs'] = this.getCostingAnalysisSumByJobData.length ? this.getCostingAnalysisSumByJobData.length : '-';
				temp['Jobs Pending Completion'] = (this.getCostingAnalysisSumByJobData.length - tempChecking) ? (this.getCostingAnalysisSumByJobData.length - tempChecking) : '-';
				temp['Jobs Completed'] = tempChecking;
				temp['Jobs Not Billed'] = isNaN(JobNotBilledList) ? 0 : JobNotBilledList ;
				// temp['Jobs Billed'] = this.getCostingAnalysisSumByJobData.length - JobNotBilledList;
				temp['Jobs Billed'] = isNaN(JobBilledList) ? 0 : JobBilledList ;
				temp['Amount Billed'] = tempAmountBilled ? tempAmountBilled : '-';
				temp['Total Gross Profit'] = tempTotalGP ? tempTotalGP : '-';
				let tempprofit = (((AmountBilled - CostExclTax) / AmountBilled) * 100) ? (((AmountBilled - CostExclTax) / AmountBilled) * 100) : '-';
				temp['Gross Profit %'] = AmountBilled == 0 ? 'N/A' :(tempprofit.toFixed(2) ? `${tempprofit.toFixed(2)}%` : '-');

				let newDataFilter = {}; 
        newDataFilter[`${this.selectedDateFieldInfo ? this.selectedDateFieldInfo : 'Date'}`] =  `${this.fromDatePicker ? this.fromDatePicker.formatString('yyyy-MM-dd') : null } to ${this.toDatePicker ? this.toDatePicker.formatString('yyyy-MM-dd') : null}`;
        newDataFilter['As At Date' ] =   this.asAtDatePicker ? this.asAtDatePicker.formatString('yyyy-MM-dd') : null ;
        newDataFilter['Group By' ] =   this.selectedAnalysisTypeInfo;
        newDataFilter['Job Status' ] =   this.selectedJobStatusInfo;
        newDataFilter['G/L Acc' ] =   this.filteredGlAcc.length == 0 ? "All" : this.getGlAcc;
        newDataFilter['Charge Code' ] =   this.filteredChargeCode.length == 0 ? "All" : this.getChargeCode;
        newDataFilter['Job Type' ] =   this.filteredJobType.length == 0 ? "All" :  this.getJobType;
        newDataFilter['Customer' ] =   this.filteredCustomer.length == 0 ? "All" : this.getCustomerCode;
        newDataFilter['Total G. Profit Margin %' ] =   AmountBilled == 0 ? 'N/A' :(tempprofit.toFixed(2) ? `${tempprofit.toFixed(2)}%` : '-');
        this.dataFilter = newDataFilter;
				
				this.$nextTick(() => {
					this.filteredJobObject = temp;
					this.filterLoaderEightBoxes = false;
				});
			}
		},
		checkError: function () {
			if (!this.selectedDateField) {
				this.selectedDateFieldInfo = '';
				this.$showAlert('error', 'Invalid Date Field', 'Please select a valid Date Field from the dropdown list');
				this.isRefreshed = false;
				this.tableIsLoading = false;
				this.filterLoaderRefreshButton = false;
				this.filterLoaderEightBoxes = false;
				this.filterLoaderTableBox = false;
				this.filterLoaderTopLeftContainer = false;
				this.filterLoaderTopRightContainer = false;
				this.filterLoaderBottomLeftContainer = false;
				this.filterLoaderBottomRightContainer = false;
				return;
			}
			if (!this.selectedAnalysisType) {
				this.$showAlert('error', 'Invalid Analysis Type', 'Please select a valid AnalysisType from the dropdown list');
				this.isRefreshed = false;
				this.tableIsLoading = false;
				this.filterLoaderRefreshButton = false;
				this.filterLoaderEightBoxes = false;
				this.filterLoaderTableBox = false;
				this.filterLoaderTopLeftContainer = false;
				this.filterLoaderTopRightContainer = false;
				this.filterLoaderBottomLeftContainer = false;
				this.filterLoaderBottomRightContainer = false;
				return;
			}
			if (!this.selectedJobStatus) {
				this.selectedJobStatusInfo = '';
				this.$showAlert('error', 'Invalid Job Status', 'Please select a valid Job Status from the dropdown list');
				this.isRefreshed = false;
				this.tableIsLoading = false;
				this.filterLoaderRefreshButton = false;
				this.filterLoaderEightBoxes = false;
				this.filterLoaderTableBox = false;
				this.filterLoaderTopLeftContainer = false;
				this.filterLoaderTopRightContainer = false;
				this.filterLoaderBottomLeftContainer = false;
				this.filterLoaderBottomRightContainer = false;
				return;
			}
		},
		showasat: function (e) {
			console.log(e);
			// if(e == '')
		},
		formatCurrency: function (format, value) {
			let [group, sym, numOfDigits] = format.split('');
			try {
				if (typeof value == 'string') {
					value = parseFloat(value);

				}
				let temp = value.toFixed(numOfDigits);
				let [front, back] = temp.split('.');
				let result = `${Number(front).toLocaleString()}${sym}${back}`
				result = result.replace(',', group)
				return result;
			} catch (e) {
				console.error(e);
			}
		},
	},
	async mounted() {
		this.$bus.$on('pageSASControlAccess', (x) => {

			if (x.page == 'EMS Part Type') {
				x.data.forEach(k => {
					//key in menu same as control value from api
					let selectedMenu = this.menu.find(m => m['key'] == k['Control']);
					if (selectedMenu) {
						selectedMenu[k['Properties'].toLowerCase()] = (k['PropertiesValue'] == 'True');
					}
				})
			}
		})

		// this.loading = true;

		// this.loadText = 'Getting Date Fields';
		this.$fullscreenLoading('Getting Date Fields');
		this.dateFieldItems = await this.$apiCallV2('/Master/GetListMaster', {masterfile : 'JOBCOSTING_DATEFIELD'});
		this.$fullscreenLoading('Getting Analysis Type');
		this.analysisTypeItems = await this.$apiCallV2('/Master/GetListMaster', {masterfile : 'JOBCOSTING_GROUPBY'});
		this.$fullscreenLoading('Getting Job Status');
		this.jobStatusItems = await this.$apiCallV2('/Master/GetListMaster', {masterfile : 'JOBCOSTING_JOBSTATUS'}) || [];
		this.billpaidItems = await this.$apiCallV2('/Master/GetListMaster', {masterfile : 'JOBCOSTING_BILLEDPAID'}) || [];
		this.chkCNItems = await this.$apiCallV2('/Master/GetListMaster', {masterfile : 'JOBCOSTING_CREDITNOTE'}) || [];
		this.chkMiscRtItems = await this.$apiCallV2('/Master/GetListMaster', {masterfile : 'JOBCOSTING_MISCRECEIPT'}) || [];
		this.showItems = await this.$apiCallV2('/Master/GetListMaster', {masterfile : 'JOBCOSTING_SHOW'}) || [];
		// first data in drop down selected when load in (default)
		
		
		this.selectedbillpaid =  this.billpaidItems.length > 0 ? this.billpaidItems[0] : null;
		this.selectedbillpaidInfo = this.billpaidItems.length > 0 ? this.selectedbillpaid['Charge Status Desc'] : '';

		this.selectedchkCN = this.chkCNItems.length > 0 ? this.chkCNItems[0] : null;
		this.selectedchkCNInfo = this.chkCNItems.length > 0 ?  this.selectedchkCN['Credit Note Status'] : '';

		this.selectedchkMiscRt = this.chkMiscRtItems.length > 0 ? this.chkMiscRtItems[0] : null;
		this.selectedchkMiscRtInfo = this.chkMiscRtItems.length > 0 ?  this.selectedchkMiscRt['Misc Rt Status'] : '';

		this.selectedshow = this.showItems.length > 0 ? this.showItems[0] : null;
		this.selectedshowInfo = this.showItems.length > 0 ?  this.selectedshow['Show Status'] : '';

		this.selectedDateField = this.dateFieldItems.length > 0 ? this.dateFieldItems[0] : null;
		this.selectedDateFieldInfo = this.dateFieldItems.length > 0 ?  this.selectedDateField['Date Field'] : '';

		this.selectedAnalysisType = this.analysisTypeItems.length > 0 ? this.analysisTypeItems[0] : null;
		this.selectedAnalysisTypeInfo = this.analysisTypeItems.length > 0 ?  this.selectedAnalysisType['Group By'] : '';

		this.selectedJobStatus = this.jobStatusItems.length > 0 ? this.jobStatusItems[0] : null;
		this.selectedJobStatusInfo = this.jobStatusItems.length > 0 ?  this.selectedJobStatus['Job Status'] : '';

		// load filter details

		this.$fullscreenLoading('Getting G/L Account');
		this.glAccData = await this.$apiCallV2('/Master/GetListMaster', {masterfile : 'GLACCOUNT'});

		this.$fullscreenLoading('Getting Charges Code');
		this.chargeCodeData = await this.$apiCallV2('/Master/GetListMaster', {masterfile : 'CHARGESCODE'});

		this.$fullscreenLoading('Getting Customer');
		this.customerData = await this.$apiCallV2('/Master/GetListMaster', {masterfile : 'BILLCUSTNAME'});

		this.$fullscreenLoading('Getting Job Type');
		this.JobTypeData = await this.$apiCallV2('/Master/GetListMaster', {masterfile : 'SYSTEM_JOBTYPE'});

		this.analysisTypeConversion = [
			{ 'Customer': { columnName: 'Customer Code', isCus: true } },
			{ 'Customer GL Code': { columnName: 'GL Code', isCus: true } },
			{ 'Job': { columnName: 'Job #', isCus: false } },
			{ 'Sales Person': { columnName: 'Sales Person', isCus: false } },
			{ 'Sales Team': { columnName: 'Sales Team', isCus: false } },
			{ 'Service Person': { columnName: 'Service Person', isCus: false } },
			{ 'Service Team': { columnName: 'Service Team', isCus: false } },
			{ 'Shipper/Consignee': { columnName: 'Shipper Name', isCus: false } },
		];

		this.analysisType = [
			{ 'Customer': { columnName: 'Customer', isCus: true } },
			{ 'Customer GL Code': { columnName: 'Customer', isCus: true } },
			{ 'Job': { columnName: 'Job #', isCus: false } },
			{ 'Sales Person': { columnName: 'Sales Person', isCus: false } },
			{ 'Sales Team': { columnName: 'Sales Team', isCus: false } },
			{ 'Service Person': { columnName: 'Service Person', isCus: false } },
			{ 'Service Team': { columnName: 'Service Team', isCus: false } },
			{ 'Shipper/Consignee': { columnName: 'Consignee', isCus: false } },
		];

		this.isRefreshed = false;
		this.$fullscreenLoading('');
		// this.loading = false;

		vuePage = this;
		window.addEventListener('resize', this.addChartListeners);
		window.addEventListener('resize', this.addChartLabelHoverListeners);

	},
};
</script>

<style lang="scss" scoped>
@import "@/css/all.scss";

.job-costing-main {
	display: flex;
	padding: 5px 45px;
	font-size: 12px;

	>.left-container {
		height: 100%;
		min-width: 255px;
		background-color: white;
		border-radius: 5px;
		padding: 4px;
		display: flex;
		flex-direction: column;
		transition: $transition-time;
		overflow: hidden;

		>.separator {
			height: 20px;
		}

		>.date-section {
			border: 1px solid rgb(200, 200, 200);
			border-radius: 5px;
			padding: 5px;
			width: 100%;
			display: flex;
			flex-direction: column;

			>.container {
				display: flex;
				justify-content: center;
				align-items: center;
				width: 100%;

				>.container-one {
					margin-left: -15px;
					margin-right: 2px;
					width: 100%;
					height: 100%;
				}


			}
		}

		>.filter-container {
			position: relative;
			width: 100%;
			height: 100%;
			flex-wrap: wrap;

			>.filter-table1 {
				height: calc(100% - 500px);
				min-height: 200px;
				display: flex;

				>.gl-acc-filter>.charge-code-filter {
					height: 100%;
				}
			}

			>.filter-table2 {
				height: calc(100% - 500px);
				min-height: 200px;
				display: flex;

				>.customer-filter>.job-type-filter {
					height: 100%;
				}
			}
		}
	}

	>.right-container {
		height: 100%;
		max-width: calc(100% - 250px);
		min-width: calc(100% - 250px);
		margin-left: 4px;
		display: flex;
		flex-direction: column;
		transition: $transition-time;
		position: relative;
		overflow: hidden;

		>.filtered-result {
			display: flex;
			width: 100%;
			flex-direction: row;
			height: auto;

			>.filtered-left {
				width: 100%;
				position: relative;

				>.filtered-section {
					background-color: white;
					border-radius: 5px;
					padding: 5px;
					position: relative;
					display: flex;
					justify-content: space-between;
					overflow: auto;
					margin-bottom: 5px;

					> :nth-child(1) {
						padding-right: 10px;
					}

					>.filtered-items {
						width: 100%;
						text-overflow: ellipsis;
						white-space: nowrap;
						border-radius: 5px;
						overflow: hidden;

						>.filtered-row {
							width: 100%;
							display: flex;
							padding-bottom: 3px;

							>.filter-title {
								max-width: 100px;
								min-width: 100px;
							}

							>.colon-separator {
								margin: 0 5px;
							}

							>.filter-details {
								width: 100%;
							}
						}
					}

					>.refresh-section {
						display: flex;
						width: 100%;
						justify-content: flex-end;
						align-items: start;
						text-overflow: ellipsis;
						white-space: nowrap;
						overflow: hidden;
					}
				}
			}

		}

		>.super-container {
			display: flex;
			flex-direction: column;
			height: 100%;
			width: 100%;

			>.eight-boxes {
				display: flex;
				flex-direction: row;
				max-height: 80px;
				min-height: 80px;
				//height: 80px;
				justify-content: space-between;
				margin-bottom: 5px;
				width: 100%;
				overflow: auto;

				> :last-of-type {
					margin-right: 0;
				}

				>.filter-box {
					background-color: white;
					border-radius: 5px;
					height: 100%;
					//width: 185px;
					//flex-grow: 1;
					display: flex;
					flex-direction: column;
					justify-content: center;
					align-items: center;
					text-align: center;
					margin-right: 5px;
					/* max-width: 300px; */
					width: 100%;

					>span {
						font-weight: bold;
					}

					>span#data {
						font-size: 150%;
					}


					>span#label {
						padding: 5px;
						text-transform: capitalize;
					}
				}
			}

			>.for-chart {
				width: 100%;
				height: 100%;

				> :nth-child(1) {
					margin-bottom: 5px;
				}

				> :nth-child(2) {
					margin-bottom: 5px;
				}

				>.chart-container {
					display: flex;
					align-items: center;
					justify-content: center;
					width: 100%;
					height: calc(50% - 15px);

					>.chart {
						background-color: white;
						width: 100%;
						height: 100%;
						border-radius: 3px;
						font-size: 12px;


						>.new-container {
							display: flex;
							height: 100%;
							padding-bottom: 5px;
							width: 100%;
							justify-content: space-between;

							>.legend {
								height: 100%;
								width: 40%;
								padding-left: 3px;
								margin: 3px;

								>.legend-row {
									display: flex;
									align-items: center;
									width: 100%;
									height: 100%;

									>.table {
										width: 100%;
										height: calc(100% - 50px);
										overflow: scroll;
										line-height: 1;
										padding-bottom: 5px;

										>.details-table {
											width: 100%;
											height: 100%;
											border: 1px solid black;
											font-size: 10px;
										}
									}
								}
							}
						}

						>.chart-title {

							color: black;
							font-weight: bold;
							position: relative;

							>span {
								position: absolute;
								top: 5px;
								left: 5px;
							}

							>#enlargeButton {
								width: 15px;
								height: 15px;
								position: absolute;
								right: 0;
								top: 0;
								cursor: pointer;
							}

							>#enlargeButton:hover {
								transition: $transition-time;
								transform: scale(1.5);
							}
						}

						>.ct-chart-top50atpm {
							height: calc(100% - 30px);
							/* height: 95%; */
							// width: 100%;
							width: calc(100% - 20px);
							margin-left: 20px;
						}

						>.ct-chart-btm50atpm {
							height: calc(100% - 30px);
							/* height: 95%; */
							width: calc(100% - 20px);
							margin-left: 20px;
							/* padding-right: 5px; */
							//  padding-left: 5px;
						}
					}
				}

			}


		}

		/* > .table-hover:hover {
			min-height: 90px;
			transition: $transition-time;
			border: 1px solid black;
			display: flex;
			justify-content: center;
			align-items: center;
			border-width: 2px;

			> .table-box-label {
				font-weight: bold;
				padding: 0;
			}
		} */

		>.table-box-container {
			max-height: 20px;
			min-height: 20px;
			background-color: white;
			border-radius: 5px;
			width: 100%;
			position: absolute;
			bottom: 0;
			left: 0;
			transition: $transition-time;
			height: 80%;
			display: flex;
			z-index: 9999;
			justify-content: space-between;
			align-items: center;

			>.table-box-close-label {
				position: absolute;
				width: 100%;
				text-align: center;
				top: 2%;
				font-weight: bold;
			}


			>.table-box-content {
				width: 100%;
				height: 100%;
			}

			>.table-box-label {
				padding-left: 5px;
			}

			>.table-box-icon {
				height: 20px;
				width: 20px;
				border-radius: 50%;
				border: 1px solid black;
				display: flex;
				justify-content: center;
				align-items: center;
				transition: 0.3s;
				cursor: pointer;
				margin-right: 5px;

				img {
					height: 10px;
					width: 10px;
				}

				&:hover {
					transform: scale(1.5);
				}
			}

			>.close-button {
				position: absolute;
				top: 0;
				right: 0;
				background-color: indianred;
			}
		}
	}

	>.chart-tooltip {
		position: fixed;
		top: 100%;
		left: 100%;
		padding: 5px;
		background-color: rgba(0, 0, 0, 0.55);
		color: white;
		z-index: 9999;
	}
}

.ct-chart-topjobspm {
	width: 95%;
	height: 90%;
	display: flex;
	align-items: center;
	justify-content: center;
}

.section-loader {
	background-color: rgba(200, 200, 200, 0.3);
	z-index: 1;
	position: absolute;
	width: 100%;
	height: 80px;
	border-radius: 5px;
	display: flex;
	align-items: center;
	justify-content: center;
	text-align: center;

}

.section-loader-text {
	background-color: white;
	border-radius: 5px;
	user-select: none;
	box-shadow: 0 0 8px #0004;
	font-size: 12px;
	display: flex;
	width: fit-content;
	padding: 5px;
}

.section-loader-button {
	background-color: rgba(200, 200, 200, 0.3);
	z-index: 1;
	position: absolute;
	width: 238px;
	height: 143px;
	margin-bottom: 25px;
	border-radius: 5px;
	display: flex;
	align-items: center;
	justify-content: center;
	text-align: center;

}

.section-loader-chart {
	background-color: rgba(200, 200, 200, 0.3);
	z-index: 1;
	position: absolute;
	width: 100%;
	height: 36%;
	border-radius: 5px;
	display: flex;
	align-items: center;
	justify-content: center;
	text-align: center;

}

@media only screen and (max-width: 1145.21px) {
	.job-costing-main {
		>.right-container {
			>.filtered-result {
				overflow-y: scroll;
				overflow-x: scroll;

				>.filtered-left {
					>.filtered-section {
						// min-height: 100px;
						min-height: 100%;
					}
				}

				>.filtered-right {
					>.filter-box {
						// min-height: 100px;
						min-height: 100%;
					}
				}
			}

			>.chart-container {
				flex-direction: column;

				> :nth-child(1) {
					margin-right: 0;
					margin-bottom: 5px;
				}

				>.chart {
					width: 100%;
					border-radius: 5px;
					min-height: 20px;

					>.new-container {
						height: 100%;
						width: 100%;

						>.ct-chart-topjobspm {
							height: 100%;
							padding-top: 15px;
							width: 100%;
						}

						>.legend {
							padding-top: 8px;
							padding-bottom: 20px;
						}
					}

				}
			}
		}
	}

	.table-box-container {
		[class*="col-"] {
			width: 100%;
			min-height: 50%;
		}
	}
}

// css for legend

tr td:nth-child(1) {
	font-weight: bold;
}

tr:nth-child(1) {

	text-align: left;

	>th:nth-child(1) {
		text-align: left;
	}
}

td {
	text-align: right;
}

td:nth-child(1) {
	text-align: right;
}

tr:nth-child(2) td:nth-child(1) {
	background-color: rgb(230, 230, 250);
}

tr:nth-child(3) td:nth-child(1) {
	background-color: rgb(216, 191, 216);
}

tr:nth-child(4) td:nth-child(1) {
	background-color: rgb(221, 160, 221);
}

tr:nth-child(5) td:nth-child(1) {
	background-color: rgb(147, 112, 219);
}

tr:nth-child(6) td:nth-child(1) {
	background-color: rgb(153, 50, 204);
}

tr:nth-child(7) td:nth-child(1) {
	background-color: rgb(75, 0, 130);
}
</style>